import type { CSSProperties } from 'react';

import { initialsOf, toneFor } from '@/lib/avatar';
import { cx } from '@/lib/cx';

import styles from './Avatar.module.css';

export type AvatarProps = {
  name: string;
  /** A path returned by the API, already resolved to a URL by the caller. */
  src?: string | null;
  size?: number;
  className?: string;
};

export function Avatar({ name, src, size = 34, className }: AvatarProps) {
  const style: CSSProperties = {
    inlineSize: size,
    blockSize: size,
    fontSize: Math.round(size * 0.35),
    background: src ? 'var(--hairline)' : toneFor(name),
  };

  return (
    <div className={cx(styles.avatar, className)} style={style}>
      {src ? (
        // Decorative: the name is always beside it. An alt of the name would have a
        // screen reader read every name twice down a list.
        <img className={styles.image} src={src} alt="" />
      ) : (
        <span aria-hidden="true">{initialsOf(name)}</span>
      )}
    </div>
  );
}
